export function isBrowser(): boolean {
  return typeof window !== 'undefined'
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function camelToSnake(camelText: string) {
  // camelCase를 snake_case로 변환
  return camelText
    .replace(/([a-z\d])([A-Z])/g, '$1_$2') // 소문자/숫자 다음에 대문자가 오면 _를 추가
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1_$2') // 연속된 대문자 처리
    .replace(/([a-z])(\d)/g, '$1_$2') // 소문자 다음에 숫자가 오면 _를 추가
    .replace(/(\d)([A-Z])/g, '$1_$2') // 숫자 다음에 대문자가 오면 _를 추가
    .toLowerCase() // 모두 소문자로 변환
}

export function snakeToCamel(snakeText: string) {
  return snakeText
    .split('_')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('')
}
